import React from 'react';

import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';

import { wordCount } from '../../utils/wordCount';
import { Text } from '../Text/Text';

interface Props {
  limit: number;
  text: string;
  mode?: 'characters' | 'words';
}

export const CharacterLimit = ({ limit, mode = 'characters', text }: Props) => {
  const formatNumber = useFormatNumber();
  const count = mode === 'characters' ? text.length : wordCount(text);
  const preset = count > limit ? 'error' : 'description';
  return (
    <Text preset={preset}>
      {formatNumber(count)}/{formatNumber(limit)} {mode}
    </Text>
  );
};
